type Vendor = 'amazon' | 'walmart' | 'target' | 'etsy' | 'the_knot' | 'babylist' | 'zola';

export const affiliateVendors: Record<string, Vendor> = {
  AMAZON: 'amazon',
  WALMART: 'walmart',
  TARGET: 'target',
  ETSY: 'etsy',
  THE_KNOT: 'the_knot',
  BABYLIST: 'babylist',
  ZOLA: 'zola',
};

const AFFILIATE_ID_MAP: Partial<Record<Vendor, string>> = {
  amazon: 'tag',
  walmart: 'affiliates_ad_id',
  target: 'afid',
};

const WALMART_AFFILIATE_URL =
  'https://goto.walmart.com/c/3858077/565706/9383?veh=aff&sourceid=imp_000011112222333344';
const TARGET_AFFILIATE_URL =
  'https://goto.target.com/c/2310483/81938/2092?subId1=A&subId2=B&subId3=C&sharedid=D&partnerpropertyid=2052984';
const ETSY_AFFILIATE_URL = 'https://www.awin1.com/cread.php?awinmid=6220&awinaffid=1238431';
const THE_KNOT_AFFILIATE_URL = ''; // TODO: Add The Knot affiliate URL
const BABYLIST_AFFILIATE_URL = ''; // TODO: Add Babylist affiliate URL
const ZOLA_AFFILIATE_URL = ''; // TODO: Add Zola affiliate URL

export function addAmazonAffiliateTag(url: string, params: Record<string, string>) {
  const urlObj = new URL(url);
  Object.entries(params).forEach(([key, value]) => {
    urlObj.searchParams.set(key, value);
  });
  return urlObj.toString();
}

export function extractHtmlATags(htmlString: string) {
  const regex = /<a[^>]*>([^<]+)<\/a>/gi;
  return htmlString.match(regex);
}

export function addAffiliateTag(url: string, affiliateUrl: string, tag = 'u') {
  if (!affiliateUrl) return url; // If the affiliate URL goto is empty, return the original URL
  const urlObj = new URL(affiliateUrl);
  urlObj.searchParams.set(tag, url);
  return urlObj.toString();
}

const isAlreadyAffiliateUrl = (url: URL, vendor: Vendor): boolean => {
  if (!(vendor in AFFILIATE_ID_MAP) || !AFFILIATE_ID_MAP[vendor]) return false;
  return url.searchParams.has(AFFILIATE_ID_MAP[vendor]);
};

const affiliatesTags: Record<
  string,
  ((url: string) => string) | ((url: string, params: Record<string, string>) => string)
> = {
  [affiliateVendors.AMAZON]: addAmazonAffiliateTag,
  [affiliateVendors.WALMART]: (url: string) => addAffiliateTag(url, WALMART_AFFILIATE_URL),
  [affiliateVendors.TARGET]: (url: string) => addAffiliateTag(url, TARGET_AFFILIATE_URL),
  [affiliateVendors.ETSY]: (url: string) => addAffiliateTag(url, ETSY_AFFILIATE_URL, 'ued'),
  [affiliateVendors.THE_KNOT]: (url: string) => addAffiliateTag(url, THE_KNOT_AFFILIATE_URL),
  [affiliateVendors.BABYLIST]: (url: string) => addAffiliateTag(url, BABYLIST_AFFILIATE_URL),
  [affiliateVendors.ZOLA]: (url: string) => addAffiliateTag(url, ZOLA_AFFILIATE_URL),
};

export function getURLOwner(url: string) {
  const domainToOwner: Record<string, Vendor> = {
    'amazon.com': affiliateVendors.AMAZON,
    'amazon.ca': affiliateVendors.AMAZON,
    'amzn.com': affiliateVendors.AMAZON,
    'walmart.com': affiliateVendors.WALMART,
    'target.com': affiliateVendors.TARGET,
    'etsy.com': affiliateVendors.ETSY,
  };

  const regex = /https?:\/\/(www\.)?(amazon\.com|amazon\.ca|amzn\.com|walmart\.com|target\.com)/;
  const match = url.toLowerCase().match(regex);

  if (match) {
    return domainToOwner[match[2]];
  }

  return null;
}

export const putAffiliateTagsToUrl = (url: string, params: Record<string, string> = {}) => {
  const owner = getURLOwner(url);
  if (!owner) return url;
  if (isAlreadyAffiliateUrl(new URL(url), owner)) return url; // Already has affiliate tag for this vendor
  return affiliatesTags[owner](url, params);
};
